import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpService } from 'tms-lib';
import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportSupplierProductService extends TmsWebBaseImportService {
  constructor(protected httpService: HttpService) {
    super('ImportSupplierProduct', 'Supplier Products', httpService);
  }

  exportSupplierProducts(supplierId: string): Observable<any> {
    return this.httpService
      .getForText(`${this.apiUrl}/ExportSupplierProducts?supplierId=${supplierId}`)
      .pipe(tap((data: string) => this.downloadExportFile(data, 'SupplierProducts')));
  }
}
